<!--
주문하기 > 구입단가 입력 input
-->
<template>
    <div>


        <div class="uk-text-left">
            {{ currency }}
        </div>
        <input
            type="text"
            class="uk-input uk-width-1-1"
            :class="validateClass"


            :value="value"
            @input="updateValue"
        />

        <!-- 에러메세지 -->
        <div class="error-msg" v-show="errorMsg">
            {{ errorMsg }}
        </div>
    </div>

</template>

<script>
    import validatable from './validatable'

    export default {
        mixins: [
            validatable,
        ],

        // v-model 처리
        model: {
            prop: 'value',
            event: 'update:value'
        },

        props: {
            // 화폐단위
            currency: {
                type: String,
                default: null
            },
            /**
             * input 요소의 값
             */
            value: {
                type: [String, Number],
                default: ''
            },
        },
        data: function () {
            return {

            };
        },
        computed: {
        },
        methods: {
            /**
             * input 의 값이 변경되었음을 알리는 이벤트 발생
             *  - 리스너에 변경된 값을 인자로 전달
             * @param event vue 이벤트 객체
             * */
            updateValue: function (event) {
                this.$emit('update:value', event.target.value);
                this.debounceValidate();
            },

            /**
             * 검증대상 값 반환
             * @return mixed
             */
            getValidateValue() {
                return this.value;
            },

            /**
             * 검증규칙 반환
             * @return mixed
             */
            getValidateRules() {
                let rules = {};

                if (this.currency === 'KRW') {
                    rules = _.assign(rules, {
                        ignoreNull: true,
                        numeric: true,
                        gteZero: true,
                    });
                } else {
                    rules = _.assign(rules, {
                        required: true,
                        dec2digit: true,
                        gteZeroPointZeroOne: true,
                    });
                }

                return rules;
            },


        },
    }
</script>

<style lang="scss" scoped>
    input {
        text-align: center;
        font-size: 1.25rem;
        color: #000;
        border: 1px solid #666;
        //border: 1px solid #1e87f0;

        &.validate-ing {// 검증-중 상태
            border-color: #666;
        }
        &.validate-success {// 검증-성공 상태
            border-color: #009a67;
        }
        &.validate-error {// 검증-오류 상태
            border-color: #f0506e;
        }


    }

    // 오류메세지
    .error-msg{
        color: #f0506e ;
        font-size: 0.875rem;
        text-align: right;
    }

</style>